<template>
  <div class="info-form">
    <Form
      ref="formValidate"
      :model="formValidate"
      :label-width="80"
      :rules="ruleValidate"
    >
      <FormItem label="手机号" prop="phone">
        <i-input
          v-model="formValidate.phone"
          clearable
          size="large"
          placeholder="请输入手机号"
        ></i-input>
      </FormItem>
      <FormItem label="验证码" prop="checkNum">
        <i-input
          v-model="formValidate.checkNum"
          size="large"
          placeholder="请输入验证码"
        >
          <Button
            slot="append"
            :disabled="disabled"
            :class="disabled === true ? 'on' : ''"
            @click="getcheckNum"
          >
            {{ text }}
          </Button>
        </i-input>
      </FormItem>
      <FormItem label="密码" prop="password">
        <i-input
          type="password"
          v-model="formValidate.password"
          clearable
          size="large"
          placeholder="请输入你的密码"
        ></i-input>
      </FormItem>
      <FormItem label="确认密码" prop="repassword">
        <i-input
          type="password"
          v-model="formValidate.repassword"
          clearable
          size="large"
          placeholder="请再次输入你的密码"
        ></i-input>
      </FormItem>
      <Button
        type="error"
        size="large"
        long
        @click="handleSubmit('formValidate')"
        >注 册</Button
      >
    </Form>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { registerVerify, register } from "@api/user";
import sendVerifyCode from "@/mixins/SendVerifyCode";
export default {
  name: "CheckPhone",
  mixins: [sendVerifyCode],
  data() {
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formValidate.password) {
        callback(new Error("两次输入的密码不一样"));
      } else {
        callback();
      }
    };
    return {
      formValidate: {
        phone: "",
        checkNum: "",
        password: "",
        repassword: ""
      },
      ruleValidate: {
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          {
            type: "string",
            pattern: /^1[3|4|5|7|8][0-9]{9}$/,
            message: "手机号格式出错",
            trigger: "blur"
          }
        ],
        checkNum: [
          { required: true, message: "必须填写验证码", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 6,
            message: "验证码长度错误",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            type: "string",
            min: 6,
            message: "密码长度不能小于6",
            trigger: "blur"
          }
        ],
        repassword: [
          { required: true, validator: validatePassCheck, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    ...mapMutations(["SET_SIGN_UP_SETP"]),
    getcheckNum() {
      if (this.formValidate.phone.length === 11) {
        const data = {
          phone: this.formValidate.phone,
          type: "register"
        };
        registerVerify(data)
          .then(res => {
            if (res.status === 200) {
              this.$Message.success({
                content: "验证码已发送",
                duration: 6,
                closable: true
              });
              this.sendCode();
            }
          })
          .catch(err => {
            this.$Message.error({
              content: err.msg,
              duration: 6,
              closable: true
            });
          });
      } else {
        this.$Message.error({
          content: "请输入正确的手机号",
          duration: 6,
          closable: true
        });
      }
    },
    handleSubmit(name) {
      // 提交验证
      this.$refs[name].validate(valid => {
        if (valid) {
          const params = {
            account: this.formValidate.phone,
            captcha: this.formValidate.checkNum,
            password: this.formValidate.password,
            spread: ""
          };
          register(params)
            .then(res => {
              if (res.status === 200) {
                this.$router.push({ path: "/SignUp/signUpDone" });
                this.SET_SIGN_UP_SETP(1);
              }
            })
            .catch(err => {
              this.$Message.error({
                content: err.msg,
                duration: 6,
                closable: true
              });
            });
        } else {
          this.$Message.error({
            content: "请填写正确的信息",
            duration: 6,
            closable: true
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.info-form {
  width: 90% !important;
}
.on {
  color: #fff;
  background: #999;
}
</style>
